import { all } from 'redux-saga/effects';

import user from './user/sagas';
import requerimento from './requerimento/sagas';
import cores from './personalizacaoCor/sagas';
import home from './personalizacaoHome/sagas';
import tourBoasVindas from './boasVindas/sagas';
import extratoContribuicao from './extratoContribuicao/sagas';
import emprestimo from './emprestimo/sagas';
import telasDisponiveis from './telasDisponiveis/sagas';
import menuAtendimentoVirtual from './atendimentoVirtual/sagas';

export default function* rootSaga() {
  return yield all([
    user,
    cores,
    home,
    requerimento,
    tourBoasVindas,
    extratoContribuicao,
    emprestimo,
    telasDisponiveis,
    menuAtendimentoVirtual,
  ]);
}
